import { Box, Flex, Pagination, Select, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import classes from "./list.module.css";

type Props = {
  from: number;
  to: number;
  total: number;
  page: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
  pageSizeOptions?: string[];
};

export function ListFooter({
  from,
  to,
  total,
  page,
  pageSize,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = ["20", "40", "80", "120"],
}: Props) {
  const { t } = useTranslation("common");

  if (total <= 0) {
    return null;
  }

  const pageCount = Math.max(1, Math.ceil(total / pageSize));

  return (
    <Flex className={classes.listFooter} align="center" gap="sm" wrap="wrap">
      <Text component="span" className={classes.footerRange}>
        {t("list.recordsRange", { from, to, total })}
      </Text>
      <Box className={classes.footerSpacer} />
      <Select
        value={`${pageSize}`}
        onChange={(v) => v && onPageSizeChange(parseInt(v, 10))}
        data={pageSizeOptions}
        w={80}
        size="xs"
        radius="md"
      />
      {pageCount > 1 && (
        <Pagination
          total={pageCount}
          value={page}
          onChange={onPageChange}
          siblings={1}
          boundaries={1}
          withControls
          size="sm"
          radius="md"
        />
      )}
    </Flex>
  );
}
